import { usePartDefinition } from "@project/emerge";
import type { VolumeDefinition } from "../interfaces/VolumeProperties";
import { PartEdges } from "./PartEdges";

export const VolumeRenderer = ({ id }: { id: string }) => {
  // Nur die Eigenschaften abonnieren, die für das Rendering benötigt werden
  const partDef = usePartDefinition<VolumeDefinition>({
    id,
    select: ["size"],
  });

  if (!partDef) return null;

  const { size } = partDef;

  const width = size?.[0] || 1;
  const height = size?.[1] || 1;
  const depth = size?.[2] || 1;

  return (
    <group>
      {/* Main volume */}
      <mesh>
        <boxGeometry args={[width, height, depth]} />
        <meshStandardMaterial color="#99ccff" transparent opacity={0.7} />
        <PartEdges />
      </mesh>
    </group>
  );
};
